export const versions = {
  OFFICIAL: 'official',
  DRAFT: 'draft'
};
